import React from "react";
import splitParagraph from "../../utils/splitPara";
import aboutHero1 from "/about-hero1.webp";
import aboutHero from "/about-hero.webm";
import aboutHero2 from "/about-hero2.webp";


export const Hero: React.FC = () => {
  return (
    <div className="w-screen relative h-screen lg:px-24 md:px-16 px-8 lg:py-16 md:py-8 py-4">
      <label className="absolute left-0 w-full text-center lg:text-lg">
        From the House of Tagglabs
      </label>

      <div className="w-full h-full flex flex-col relative justify-end lg:text-8xl md:text-6xl text-4xl font-gilroy-medium lg:px-24 md:px-16 px-8">
        <div className="absolute w-full h-full left-0 flex gap-16 -z-10  items-start lg:pb-24 md:pb-16 pb-8">
          <div className="w-fit h-full flex items-center">
            <img
              src={aboutHero1}
              alt="decorative"
              className="w-[100vh] h-[50vh] object-cover rounded-[10px]"
            />
          </div>
          
          <div className="w-fit h-full flex items-end">
            <video
              src={aboutHero}
              autoPlay
              loop
              muted
              className="w-[100vh] h-[50vh] object-cover rounded-[10px]"
            />
          </div>

          <div className="w-fit h-full">
            <img
              src={aboutHero2}
              alt="decorative"
              className="w-[100vh] h-[60vh] object-cover rounded-[10px]"
            />
          </div>
        </div>
        <div className="w-full">{splitParagraph("Where\n\nImagination")}</div>
        <div className="w-full flex gap-2">
          Meets Emotion<span className="text-[#FB2C36]">.</span>
        </div>
      </div>
    </div>
  );
};
